export default __webpack_public_path__ + "static/media/Snd_TryQ.e32a45a7.mp3";